import path from 'path' // ssr
import fs from 'fs' // ssr
import * as FormData from 'form-data'

import { sendNwReq } from './index'
import { PAGE_CAREERS_DETAILS } from './queries/pages'
import { CAREERS_FILTER } from '../utils/siteConfig'

const BIRDDOGH_AUTH_URL = process.env.BIRDDOGH_AUTH_URL
const BIRDDOGH_API_URL = process.env.BIRDDOGH_API_URL
const BIRDDOGH_API_KEY = process.env.BIRDDOGH_API_KEY
const BIRDDOGH_USERNAME = process.env.BIRDDOGH_USERNAME
const BIRDDOGH_PASSWORD = process.env.BIRDDOGH_PASSWORD

/**
 * Get Authentication token
 */
async function getToken() {
  const bodyAuthParams = {
    apiKey: BIRDDOGH_API_KEY,
    userName: BIRDDOGH_USERNAME,
    password: BIRDDOGH_PASSWORD,
  }

  const authResponse = await fetch(BIRDDOGH_AUTH_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(bodyAuthParams),
  }).catch(error => console.error('BirdDogh Auth Error:', error))

  const authJson = await authResponse.json()
  return authJson?.token
}

/**
 * Get all jobs from BIRDDOGH API
 * @returns {Array} jobs
 */
async function getAllJobs() {
  const jobsFilePath = path.join(__dirname, 'temp_jobs_cache.json')
  const publishPath = __dirname.split('server')[0]
  const cachePath = path.join(publishPath, 'cache', 'last_jobs_cache.json')

  const authToken = await getToken()
  let cacheFound = false

  try {
    cacheFound = fs.statSync(jobsFilePath)
  } catch (error) {
    cacheFound = false
  }

  let apiResponse, apiJson

  if (!cacheFound) {
    // API call
    try {
      apiResponse = await fetch(BIRDDOGH_API_URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `BDToken ${authToken}`,
        },
      }).catch(error => console.error('BirdDogh API Error (getAllJobs):', error))

      apiJson = await apiResponse.json()
    } catch (error) {
      apiJson = {}
    }

    // DEV ONLY
    // try {
    //   apiResponse = await fetch(`http://morton.local/jobs2.json`, {}) // only for testing
    //   apiJson = await apiResponse.json()
    // } catch (error) {
    //   apiJson = {}
    // }

    const jsonString = JSON.stringify(apiJson)

    // cache results if success
    if (apiJson?.jobs) {
      // API SUCCESS
      await fs.writeFileSync(jobsFilePath, jsonString, err => {
        if (err) console.log('Jobs cache save error:', err)
      })

      await fs.writeFileSync(cachePath, jsonString, err => {
        if (err) console.log('Jobs last success cache save error:', err)
      })
    } else {
      // API ERROR
      submitErrorJsonCf7(jsonString)

      // get Jobs from last call API success
      try {
        apiJson = JSON.parse(fs.readFileSync(cachePath, 'utf8'))
      } catch (error) {
        console.log('Jobs last cache load error:', error)
      }
    } // end cache results
  } else {
    // get from temporary cache (OPTIMIZED BUILD CACHE)
    try {
      apiJson = JSON.parse(fs.readFileSync(jobsFilePath, 'utf8'))
    } catch (error) {
      console.log('Jobs cache load error:', error)
    }
  }

  const allJobs = apiJson?.jobs
  let filteredJobs = allJobs ? filterJobs(allJobs) : []

  return { jobs: filteredJobs }
}

/**
 * Fetch Data from WP pages
 * @param {Int} careersId
 * @param {Int} careersDetailId
 */
async function getDetailData(careersId, careersDetailId) {
  let pageData = {}
  const params = { pageIdCareers: careersId, pageIdDetails: careersDetailId }
  const result = await sendNwReq(PAGE_CAREERS_DETAILS, params)

  pageData = result?.data || {}

  return {
    pageData,
  }
}

/**
 * Log error to "Careers Log" CF7 form
 * @param {String} jsonString API response
 */
function submitErrorJsonCf7(jsonString) {
  const formdata = new FormData()

  formdata.append('name', 'Careers Log')
  formdata.append('email', 'test@ingamana.com')
  formdata.append('phone', '11')
  formdata.append('subject', 'BIRDDOGH API ERROR')
  formdata.append('message', jsonString)

  const requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow',
  }

  fetch(
    'https://bigdcompanies.wpengine.com/wp-json/contact-form-7/v1/contact-forms/2074/feedback',
    requestOptions
  )
    .then(response => response.json())
    .then(result => {})
    .catch(error => {
      console.log('Submisison Error:', error)
    })
}

/**
 * Filter jobs by location (settings in siteConfig.js, CAREERS_FILTER array)
 * @param {JSON} allJobs API response
 * @returns {JSON} filtered jobs
 */
function filterJobs(allJobs) {
  return allJobs?.filter(job => {
    let found = false

    for (let i = 0; i < job.locations.length; i++) {
      const jobLocations = job.locations
      for (let j = 0; j < jobLocations.length; j++) {
        const location = jobLocations[j]

        if (CAREERS_FILTER.indexOf(location.city) !== -1) {
          found = true
          break
        }
      }

      if (found) {
        break
      }
    }

    return found
  })
}

export { getAllJobs, getDetailData }
